export enum LegacyUserRole {
  Realtor = 'realtor',
  Sales = 'sales',
  Client = 'client',
  Admin = 'admin',
  Developer = 'developer',
  LassoApiUser = 'lasso_apiuser',
  AvesdoAdvisor = 'avesdoAdvisor',
  AvesdoCS = 'avesdoCS',
  Marketing = 'marketing'
}
